export const getSnippet = (original: string, length: number) => {
  // Clean HTML tags
  original = original.replace(/(<([^>]+)>)/gi, '')
  
  if (original.length > length) {
    return `${original.substring(0, length - 1)}...`
  }
  return original
}
